export * from './skyscraper9.component';